export default "__VITE_ASSET__DhQQZUho__"